"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var CPPFormatter = function CPPFormatter(options) {
    _classCallCheck(this, CPPFormatter);

    if (!options) {
        this.options = {
            indentWithSpaces: true,
            bracesOnNewLine: true
        };
    } else {
        this.options = options;
    }
    this.indentation = this.options.indentWithSpaces ? ' '.repeat(this.options.indentSpaceCount || 4) : '\t';
    if (this.options.bracesOnNewLine == null) {
        this.options.bracesOnNewLine = true;
    }
    this.options.bracesExist = true;
};

exports.default = CPPFormatter;